import {Component, EventEmitter, Input, Output, ViewChild} from '@angular/core';
import {TuiCarouselComponent} from '@taiga-ui/kit';
import {BaseComponent, DamElasticDTO, DamItemVersion, FileService} from 'compob2b-libs';
import {catchError, take} from 'rxjs/operators';
import {DamService} from '../../../../dam.service';
import {DamItemVersionTypeCountWSelected} from '../../dam-catalog.component';

@Component({
  selector: 'app-dam-element-preview',
  templateUrl: './dam-element-preview.component.html',
  styleUrls: ['./dam-element-preview.component.scss']
})
export class DamElementPreviewComponent extends BaseComponent {

  constructor(
    public damService: DamService,
    public fileService: FileService
  ) {
    super();
  }

  public getExtension(item): string {
    return this.damService.getExtension(item);
  }

  @Input() damElement: DamElasticDTO = null;

  @Input() set _damElement(value: DamElasticDTO) {
    this.carouselIndex = 0;
    this.filteredVersions = 0;
    this.damElement = value;
    this.cdr.detectChanges();
  }

  @Input() damItemVersions: DamItemVersion[] = [];
  @Input() damItemVersionWithDocumentInfoExtensions: string[] = [];
  @Input() fileExtensions: DamItemVersionTypeCountWSelected[] = [];
  // damItemVersionWithDocumentInfoExtensionsCount^
  isHiding = false;
  @Input() isOpen = false;
  @Output() closeEvent = new EventEmitter<boolean>();

  @ViewChild('carousel', {static: true}) carousel: TuiCarouselComponent;
  carouselIndex = 0;
  filteredVersions = 0;

  setCarouselIndex(index: number): void {
    this.carouselIndex = index;
    console.log('setCarouselIndex', this.carouselIndex);
    this.cdr.detectChanges();
  }

  cons() {
    console.log('setCarouselIndex');
  }

  onCloseEvent() {
    this.isHiding = true;
    setTimeout(() => {
      this.isOpen = false;
      this.isHiding = false;
      this.carouselIndex = 0;
      this.closeEvent.emit(true);
    }, 600);
  }

  public showThumbnail(mimeType) {
    return this.damService.showThumbnail(mimeType);
  }

  downloadDamItem() {
    this.fileService.downloadUrl('/dam-download/dam-item/' + this.damElement?.id)
      .pipe(take(1), catchError(err => this.handleError(err)))
      .subscribe(response => {
        FileService.saveAs(response, this.damElement?.header + '.zip');
      });
  }

  isAllExtensionsSelected = false;

  onAllFileExtensionsToggle(isSelected: boolean): void {
    this.toggleAll(this.fileExtensions, isSelected);
  }

  onFileExtensionToggle(index: number): void {
    this.fileExtensions[index].selected = !this.fileExtensions[index].selected;
    this.isAllExtensionsSelected = this.allItemsSelected(this.fileExtensions);
    this.filterVersions(this.damItemVersions);
  }

  allItemsSelected<T extends { selected: boolean }>(items: T[]): boolean {
    return (items.every(item => item?.selected));
  }

  allItemsUnselected<T extends { selected: boolean }>(items: T[]): boolean {
    return (items.every(item => !item?.selected));
  }

  toggleAll<T extends { selected: boolean }>(items: T[], selected: boolean) {
    this.isAllExtensionsSelected = selected;
    items.forEach(item => item.selected = selected);
    this.filterVersions(this.damItemVersions);
  }

  filterVersions(damItemVersions: DamItemVersion[]) {
    if (this.allItemsUnselected(this.fileExtensions)) {
      return damItemVersions;
    }

    const selectedExtensionsNames: string[] = this.fileExtensions.map(extension => {
      if (extension.selected) {
        return extension.typeOfFile;
      }
    }).filter(Boolean);

    this.filteredVersions = this.damItemVersions.filter((version: DamItemVersion) => {
      return selectedExtensionsNames.includes(version.mimeType);
    }).length;

    this.carouselIndex = 0;
    return damItemVersions.filter((version: DamItemVersion) => {
      return selectedExtensionsNames.includes(version.mimeType);
    });
  }

  changeApproved(damItemId: number, value: boolean) {
    this.compoApiService.post('/dam/item/' + damItemId + '/change-approved', {
      value: value
    }).pipe(take(1), catchError(err => this.handleError(err))).subscribe();
  }

  changeEnabled(damItemId: number, value: boolean) {
    this.compoApiService.post('/dam/item/' + damItemId + '/change-enabled', {
      value: value
    }).pipe(take(1), catchError(err => this.handleError(err))).subscribe();
  }

  changeDeleted(damItemId: number, value: boolean) {
    this.compoApiService.post('/dam/item/' + damItemId + '/change-deleted', {
      value: value
    }).pipe(take(1), catchError(err => this.handleError(err))).subscribe();
  }

  public downloadDamItemVersion(id: number, header: string): void {
    this.fileService.downloadUrl('/dam/download/' + this.damItemVersions[this.carouselIndex].id)
      .subscribe(response => {
        FileService.saveAs(response, this.damItemVersions[this.carouselIndex].header);
      });
  }
}
